import { Cable } from 'lucide-react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { logEvent } from '@/pages/api/v1/utils';
import { addGAEvent } from '@/utils/analytics/google/addGAEvent';
import { Button, Text } from '@music-vine/cadence/ui';

/**
 * Points partners at the API landing page. Sits beside CustomLicensingBanner
 * and keeps its look, so the pair reads as one row of "bigger" options.
 */
export const ApiBanner = () => {
  const {
    asPath
  } = useRouter();
  return <div className="flex flex-col items-start gap-4 rounded-xl border border-blue-business-200 border-solid bg-blue-business-25 p-6 sm:flex-row sm:items-center dark:border-blue-business-925 dark:bg-blue-business-975" data-sentry-component="ApiBanner" data-sentry-source-file="ApiBanner.tsx">
      <div className="flex-1">
        <Text asChild className="mb-0.5 flex items-start gap-1 font-semibold text-gray-950 text-xl dark:text-white" data-sentry-element="Text" data-sentry-source-file="ApiBanner.tsx">
          <h3>
            {/* Matches CustomLicensingBanner — icon centres on the first line. */}
            <Cable className="mt-1 size-6 shrink-0" data-sentry-element="Cable" data-sentry-source-file="ApiBanner.tsx" />
            Want to build with Uppbeat?
          </h3>
        </Text>
        <Text className="text-gray-700 text-sm dark:text-gray-400" data-sentry-element="Text" data-sentry-source-file="ApiBanner.tsx">
          Register your interest and be the first to get access to our new API.
        </Text>
      </div>
      <Button asChild size="lg" variant="bold" data-sentry-element="Button" data-sentry-source-file="ApiBanner.tsx">
        <Link href="/api" onClick={() => {
        addGAEvent('click-api-explore', {
          category: 'api',
          value: 'pricing-page-main'
        });
        void logEvent({
          event_type: 'click',
          asPath,
          metadata: {
            type: 'api_explore',
            text: 'pricing-page-main',
            next_path: '/api'
          }
        });
      }} data-sentry-element="Link" data-sentry-source-file="ApiBanner.tsx">
          Explore the API
        </Link>
      </Button>
    </div>;
};